import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const appStoreUrl = "https://apps.apple.com/ng/app/nisa-care/id6767461961";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.project.nisacare";

  const handleSectionLink = (e, sectionId) => {
    e.preventDefault();

    // If we are already on the homepage
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetTop = element.offsetTop - 120;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage and pass the section to scroll to
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-start">
          {/* Left - Logo and Tagline */}
          <Col lg={7} md={12} className="mb-4 mb-lg-0">
            <div className="footer-brand">
              <div className="nisa-logo">
                <img
                  src="/images/footer-logo.png"
                  alt="Nisa Care Logo"
                  className="footer-logo"
                />
              </div>
              <p className="footer-tagline">
                Your health, honored. Your faith, respected.<br />
                Your journey, supported at every age
              </p>
<div class="footer-app-badges">
  <a 
    href="https://apps.apple.com/ng/app/nisa-care/id6767461961" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="app-store-badge"
    aria-label="Download on the App Store"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
    </svg>
    <span>
      <small>Download on the</small>
      <strong>App Store</strong>
    </span>
  </a>
  <a 
    href="https://play.google.com/store/apps/details?id=com.project.nisacare" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="play-store-badge"
    aria-label="Get it on Google Play"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27"></path>
    </svg>
    <span>
      <small>Get it on</small>
      <strong>Google Play</strong>
    </span>
  </a>
</div>
            </div>
          </Col>

          {/* Right - Three Columns */}
          <Col lg={5} md={12}>
            <Row>
              {/* App Column */}
              <Col sm={4} xs={6} className="mb-4">
                <h6 className="footer-heading">App</h6>
                <ul className="footer-links">
                  <li>
                    <a
                      href="#how-it-works"
                      onClick={(e) => handleSectionLink(e, 'how-it-works')}
                    >
                      Journey
                    </a>
                  </li>
                  <li>
                    <a
                      href="#features"
                      onClick={(e) => handleSectionLink(e, 'features')}
                    >
                      Features
                    </a>
                  </li>
                  <li>
                    <a
                      href="#screenshots"
                      onClick={(e) => handleSectionLink(e, 'screenshots')}
                    >
                      Screenshots
                    </a>
                  </li>
                </ul>
              </Col>

              {/* Legal Column */}
              <Col sm={4} xs={6} className="mb-4">
                <h6 className="footer-heading">Legal</h6>
                <ul className="footer-links">
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </Col>

              {/* Social Column */}
              <Col sm={4} xs={12} className="mb-4">
                <h6 className="footer-heading">Social</h6>
                <ul className="footer-links">
                  <li><a href="https://www.instagram.com/nisacareofficial?igsh=MTdua3RkbTQ0cXMyeg==" target="_blank" rel="noopener noreferrer">instagram</a></li>
                  <li><a href="https://x.com/nisacare_?s=21&t=QwKzcKjRZEKeqRumc2Wt8g" target="_blank" rel="noopener noreferrer">X</a></li>
                  <li><a href="https://www.facebook.com/share/1DZACKQ5NN/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;